export const SEARCH_TERMS = ["name", "phone"];
